import { Pipe, PipeTransform } from '@angular/core';
import { DashboardUsuario } from '../../modelos/dashboard-usuario';

@Pipe({
  name: 'filtroDashboardUsuarios',
  pure: false
})
export class FiltroDashboardUsuariosPipe implements PipeTransform {

  transform(usuarios: DashboardUsuario[], filtro?: string): any {
    if (usuarios === undefined || filtro === undefined || filtro.trim() === '') {
      return usuarios;
    }
    filtro = filtro.toLocaleLowerCase();
    return usuarios.filter(usuario => usuario.usuario.nomeUsuario.toLocaleLowerCase().indexOf(filtro) >= 0);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-dashboard-usuarios.pipe.ts